{#if platform.storeData.imposter}
  <div class="cms-imposter">
    <span>You are using the following account: {impersonating}</span>
    <button on:click={stopImpersonating}>Revert to your account</button>
    <button on:click={goToHome}>Go to homepage</button>
  </div>
{/if}

<script>
  import { getContext, onMount } from 'svelte'

  const platform = getContext('platform')

  let impersonating = ''

  onMount(async () => {
    try {
      const isLoggedIn = platform.api.core.isLoggedIn()
      const personId = (isLoggedIn ? platform.storeData.auth.claims.sub : null)

      if (personId) {
        const person = await platform.api.cms.people.find(personId)

        impersonating = person.email
      }
    } catch (err) {
      console.error(err)
    }
  })

  async function stopImpersonating (e) {
    e.preventDefault()

    // Customer information, such as address, stored during basket checkout
    sessionStorage.removeItem('customerInfo')

    await platform.api.auth.impersonate(platform.storeData.imposter)
  }

  function goToHome (e) {
    e.preventDefault()

    window.location.href = '/'
  }

</script>

<style>
  .cms-imposter {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: #c21c1c;
    color: #fff;
    z-index: 4998;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>